import { render, staticRenderFns } from "./UserRolesDetailDialog.vue?vue&type=template&id=f7db51d4&scoped=true"
import script from "./UserRolesDetailDialog.vue?vue&type=script&lang=js"
export * from "./UserRolesDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRolesDetailDialog.vue?vue&type=style&index=0&id=f7db51d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7db51d4",
  null
  
)

export default component.exports